import React from "react";
import { useGame } from "@empirica/core/player/classic/react";
import { Button } from "./Button";

export function TestContinueWithoutInteraction({ onContinue, disabled = false }) {
  const game = useGame();
  const treatment = game?.get("treatment") || {};
  const design = game?.get("design") || {};
  const testMode = Boolean((treatment.testMode ?? design.testMode) ?? false);

  if (!testMode || typeof onContinue !== "function") {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50" data-no-interaction>
      <Button
        type="button"
        primary
        disabled={disabled}
        handleClick={onContinue}
      >
        Continue without interaction (test)
      </Button>
    </div>
  );
}
